/**
 * SilverTours Legacy API v1
 * https://engineering.p.silvertours.net/rentalcars/core/mietwagen/
 */ import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { api } from "@silvertours/front-shared";
var SubscriptionService = /*#__PURE__*/ function(_LegacyHTTPService) {
    "use strict";
    _inherits(SubscriptionService, _LegacyHTTPService);
    var _super = _create_super(SubscriptionService);
    function SubscriptionService() {
        _class_call_check(this, SubscriptionService);
        var _this;
        _this = _super.apply(this, arguments);
        // Newsletter subscription via Salesforce Marketing Cloud
        _this.submitNewsletterSignup = function(email, sourceParam) {
            return _this.instance.post("/newsletter/subscribe", {
                email: email,
                sourceParam: sourceParam
            });
        };
        return _this;
    }
    SubscriptionService.getInstance = function getInstance() {
        if (!SubscriptionService.classInstance) {
            SubscriptionService.classInstance = new SubscriptionService();
        }
        return SubscriptionService.classInstance;
    };
    return SubscriptionService;
}(api.LegacyHTTPService);
var subscriptionService = SubscriptionService.getInstance;
export { SubscriptionService, subscriptionService as api };
